import React from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import {
    Card,
    CardContent,
    Grid,
    Button,
    Typography,
    ListItem,
    List,
    Collapse,
    Menu,
    MenuItem,
    MenuList,
    Popper
} from "@material-ui/core";
import Images from "assets/images";
import { useTranslation } from "react-i18next";
import "./global-menu.scss";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';



export default function MenuListComposition() {

    const [open, setOpen] = React.useState(false);
    const [opens, setOpens] = React.useState(false);
    const anchorRef = React.useRef<HTMLButtonElement>(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: React.MouseEvent<EventTarget>) => {
        if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
            return;
        }

        setOpen(false);
    };

    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current!.focus();
        }

        prevOpen.current = open;
    }, [open]);

    return (
        <main>
            <div className="global_menu">
                        <List className="menu">
                            <ListItem><Button>User Info</Button></ListItem>
                            <ListItem>
                                <Button
                                    ref={anchorRef}
                                    aria-controls={open ? 'menu-list-grow' : undefined}
                                    aria-haspopup="true"
                                    onClick={handleToggle}
                                >
                                    Manage Station
                                    <ExpandMoreIcon />
                                </Button>
                                <div className='manage_listing'>
                                <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                                      <ClickAwayListener onClickAway={handleClose}>
                                        <MenuList className='detail_list' autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                            <MenuItem onClick={handleClose}>EVSE</MenuItem>
                                            <MenuItem onClick={handleClose}>Delegate</MenuItem>
                                            <MenuItem onClick={handleClose}>Member</MenuItem>
                                            <MenuItem onClick={handleClose}>Station History</MenuItem>
                                            <MenuItem onClick={handleClose}>Report</MenuItem>
                                            <MenuItem onClick={handleClose}>Analytics</MenuItem>
                                        </MenuList>
                                       </ClickAwayListener>
                                </Popper>
                                </div>
                            </ListItem>
                            <ListItem><Button>RFID Card</Button></ListItem>
                            <ListItem><Button>Member Info</Button></ListItem>
                            <ListItem><Button>User Info</Button></ListItem>
                            <ListItem><Button>Report</Button></ListItem>
                            
                        </List>
            </div>
        </main>
    );
}
